import React, {useEffect, useRef} from 'react'
import {KTSVG} from '_metronic/helpers'

interface Props {
  onHandleSearch: (text: any) => void
  searchText: string
  isFocus?: boolean
}

export const SearchBar: React.FC<Props> = ({onHandleSearch, searchText, isFocus}) => {
  const ref = useRef<any>()

  useEffect(() => {
    if (isFocus) {
      ref.current.focus()
    }
  }, [isFocus])

  const handleSearch = (e: any) => {
    const {value} = e.target
    onHandleSearch(value)
  }

  return (
    <div className='position-relative mb-3 w-100'>
      <KTSVG
        path='/media/icons/duotune/general/gen021.svg'
        className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y'
      />
      <input
        id='txtProductSearch'
        type='text'
        ref={ref}
        className='form-control px-15 border py-3'
        name='search'
        value={searchText}
        placeholder='Search for Products'
        onChange={handleSearch}
      />
    </div>
  )
}

export default SearchBar
